import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Box } from '@mui/material'
import { FC } from 'react'

interface AddressConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  customerAddress:
    | {
        street1?: string
        street2?: string
        city?: string
        state?: string
        zip?: string
        timeZone?: string
      }
    | undefined
}

export const AddressConfirmationDialog: FC<AddressConfirmationDialogProps> = ({ isOpen, onClose, onConfirm, customerAddress }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Is the Customer Address Correct?</DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontSize: 'var(--size-xs)',
            fontWeight: '300',
            lineHeight: 'var(--line-height-s, 1.125rem)',
            letterSpacing: 'var(--letter-spacing-none, 0rem)'
          }}
        >
          Please double check the customer address as this will affect dispatch in the event of an emergency
        </Typography>
        <Box sx={{ marginTop: 'var(--spacing-m)' }}>
          <Typography fontWeight="700" color="text.primary">
            Customer Address
          </Typography>
          <Typography fontWeight="400" color="text.primary" data-testid="address-confirmation-address-dialog-street">
            {customerAddress?.street1}
          </Typography>
          {customerAddress?.street2 && (
            <Typography fontWeight="400" color="text.primary" data-testid="address-confirmation-address-dialog-street">
              {customerAddress?.street2}
            </Typography>
          )}
          <Typography fontWeight="400" color="text.primary" data-testid="address-confirmation-address-dialog-city-state-zip">
            {customerAddress?.city}, {customerAddress?.state} {customerAddress?.zip}
          </Typography>
          {customerAddress?.timeZone && (
            <Typography fontWeight="400" color="text.primary" data-testid="address-confirmation-address-dialog-timezone">
              {customerAddress?.timeZone}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: 2, gap: 'var(--spacing-m)' }}>
        <Button variant="outlined" onClick={onClose} data-testid="back-to-edit">
          Cancel
        </Button>
        <Button variant="outlined" onClick={onConfirm} data-testid="confirm-address">
          Yes, it's correct
        </Button>
      </DialogActions>
    </Dialog>
  )
}
